import React from 'react';
import { Button, Dialog } from '@mui/material';

/**
 * @typedef {object} RemoveCheckPointWarningModalProps
 * @property {boolean} open
 * @property {number} appraisalId
 * @property {string} [dataCollectionDate]
 * @property {(event: object, reason?: 'backdropClick' | 'escapeKeyDown') => void} onCancel
 * @property {(event?: React.MouseEvent) => void} onRemove
 */

/**
 * @param {RemoveCheckPointWarningModalProps} props
 */
const RemoveCheckPointWarningModal = props => {
  const { open, appraisalId, dataCollectionDate, onCancel, onRemove } = props;
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth='md'
      fullWidth
      data-testid='remove-checkpoint-modal'>
      <div className='remove-modal'>
        <h2>
          Are you sure you want to remove
          <br />
          Check Point {dataCollectionDate} from Appraisal {appraisalId}
          <br />
          Removed data cannot be restored
        </h2>
        <div className='action-button-group'>
          <Button
            data-testid='cancel-button'
            className='secondary-button flex'
            type='button'
            onClick={onCancel}>
            Cancel
          </Button>
          <Button
            data-testid='confirm-button'
            className='primary-button lg'
            type='submit'
            onClick={onRemove}>
            Remove Check Point
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default RemoveCheckPointWarningModal;
